import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {AccountModel} from "../../domain/models/account.model";
import {
  CustomerFormComponent
} from "../../pages/search/customer/search-customer-detail/components/customer-form-component";
import {AddressInfoCardComponent} from "../address-info-card/address-info-card.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {Icons} from "../../domain/enums/icons-enums";
import {CurrencyInputDirective} from "../../utils/directives/currency-input.directive";
import {MatButton} from "@angular/material/button";
import {MatDivider} from "@angular/material/divider";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {StatusIndicatorComponent} from "../status-indicator/status-indicator.component";
import {MatCard} from "@angular/material/card";
import {MatCheckbox} from "@angular/material/checkbox";
import {LicensesComponent} from "../licenses/licenses.component";
import {FormValidationUtil} from "../../utils/form-validation.util";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-account-mgmt-profile',
  standalone: true,
  imports: [
    AddressInfoCardComponent,
    CurrencyInputDirective,
    MatButton,
    MatDivider,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    StatusIndicatorComponent,
    MatCard,
    MatCheckbox,
    LicensesComponent,
    MatError,
    NgIf
  ],
  templateUrl: './account-mgmt-profile.component.html',
  styleUrl: './account-mgmt-profile.component.css'
})
export class AccountMgmtProfileComponent  implements OnInit, CustomerFormComponent, OnChanges {
  @Input() account!: AccountModel;
  @ViewChild(AddressInfoCardComponent) addressInfo!: AddressInfoCardComponent;
  @ViewChild(LicensesComponent) licenses!: LicensesComponent;
  contactInfoForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.buildForm(this.account);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.buildForm(this.account);
  }

  buildForm(info: AccountModel): void {
    this.contactInfoForm = this.fb.group({
      businessLegalName: [info?.businessLegalName?? '', Validators.required],
      businessDbaName: [info?.businessDbaName?? '', Validators.required],
      webSiteUrl: [info?.webSiteUrl?? '', [
        Validators.pattern(FormValidationUtil.getUrlValidationPattern())]],
      eSignature: [{value:info?.printedName?? '', disabled:true}],
      status: [info?.status ?? '', Validators.required],
      billingFreq: [ info?.frequency, Validators.required],
      credit: [ info?.credit, [Validators.required,
        Validators.pattern(FormValidationUtil.getCurrencyValidationPattern())]],
      primaryContactFirstName: [ info?.primaryContactFirstName, Validators.required],
      primaryContactLastName: [ info?.primaryContactLastName, Validators.required],
      primaryContactEmail: [ info?.primaryContactEmail, [Validators.required, Validators.email]],
      primaryContactPhoneNumber: [ info?.primaryContactPhoneNumber, [Validators.required,
        Validators.pattern(FormValidationUtil.getPhoneValidationPattern())]],
    });
  }

  getContactInfoForm(): AccountModel {
    const formData = this.contactInfoForm.value;

    return {
      businessLegalName: formData.businessLegalName,
      businessDbaName: formData.businessDbaName,
      webSiteUrl: formData.webSiteUrl,
      status: formData.status,
      frequency: formData.billingFreq,
      credit: formData.credit,
      primaryContactFirstName: formData.primaryContactFirstName,
      primaryContactLastName: formData.primaryContactLastName,
      primaryContactEmail: formData.primaryContactEmail,
      primaryContactPhoneNumber: formData.primaryContactPhoneNumber
    };
  }


  getUpdatedAccount(): AccountModel {
    return {
      ...this.account,
      ...this.getContactInfoForm(),
      ...this.addressInfo.getAddressInfoFromForm()
    };
  }

  isFormValid(): boolean {
    return this.contactInfoForm.valid &&
      this.addressInfo.isFormValid();
  }

  raiseFormValidations(): void {
    this.contactInfoForm.markAllAsTouched();
    this.addressInfo.raiseFormValidations();
  }


  protected readonly icons = Icons;
}
